import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';
import {
  StyledGroupContainer,
  StyledName,
  StyledGoals,
  StyledNoWinner,
  StyledNotAvailable,
} from './styled';
import { showMobileSidebarSection } from '../../../redux/actions/Team';
import { leagueSetTeamInfo } from '../../../redux/actions/League';
import { POPUPS } from '../../../service/constants';
import { showPopupWindow } from '../../../redux/actions/Popups';
import { getMyCurrentTeam } from '../../../redux/selector/User';

const GroupTeamMobile = ({ teamData = {}, side }) => {
  const dispatch = useDispatch();
  const currentTeam = useSelector(getMyCurrentTeam);
  const { symbol = '', name = '', score = null } = teamData;
  const notScored = score === -1 || score === null;
  const own = Boolean(
    currentTeam?._id && teamData?._id && currentTeam._id === teamData._id
  );
  const showTeamInfo = (id) => {
    if (!id) return;
    const { TEAM_INFO_POPUP } = POPUPS;
    dispatch(leagueSetTeamInfo({ _id: id }, isMobileOnly));
    if (isMobileOnly) {
      dispatch(showMobileSidebarSection('teamInfo'));
    } else {
      dispatch(showPopupWindow(TEAM_INFO_POPUP, TEAM_INFO_POPUP, true));
    }
  };
  return (
    <StyledGroupContainer side={side} $own={own}>
      <StyledName onClick={() => showTeamInfo(teamData._id)} side={side}>
        {name ? (
          <span>{name}</span>
        ) : (
          <StyledNotAvailable>Not available</StyledNotAvailable>
        )}
        {symbol ? <img src={symbol} alt="team logo" /> : <StyledNoWinner />}
      </StyledName>
      <StyledGoals side={side} $pending={notScored}>
        {notScored ? '?' : score}
      </StyledGoals>
    </StyledGroupContainer>
  );
};

export default GroupTeamMobile;
